import * as yup from 'yup';

export const createPortalSchema = yup.object().shape({
  // Portal Information
  name: yup
    .string()
    .required('Portal name is required')
    .max(200, 'Portal name must be at most 200 characters'),

  // Contact Information
  contact_name: yup.string().default(''),
  contact_email: yup
    .string()
    .default('')
    .email('Please enter a valid email address'),
  contact_phone: yup.string().default(''),

  // Embedding
  embedding_provider: yup.string().default(''),
  embedding_model: yup
    .string()
    .required('Embedding model is required'),

  // Branding
  primary_color: yup.string().default(''),
  secondary_color: yup.string().default(''),
});

export type CreatePortalFormValues = yup.InferType<typeof createPortalSchema>;
